import React from 'react'
import {Button} from '../../../shared/Button'
import {
  BannerWrap,
  BannerMessage,
  ColumnsRow,
  Column,
  RecommendedColumn,
  RecommendedDetails,
  ColumnLabel,
  MapImage,
  TokenText,
} from './AddressSuggestionBanner.styles'

const {REACT_APP_GOOGLE_API_KEY: API_KEY} = process.env

const formatAddress = ({address, city, state, zipCode}) =>
  [address, `${city}, ${state} ${zipCode}`].filter(Boolean).join(', ')

const Token = ({value, changed}) => (
  <TokenText changed={changed}>{value}</TokenText>
)

// Inline, non-blocking version of AddressSuggestionModal's "what you
// entered" vs "recommended" comparison — shown next to the editable
// address fields (instead of a separate confirm dialog) so the rep can
// either apply the recommendation with one click or just edit the fields
// directly below it.
export function AddressSuggestionBanner({
  suggestion,
  onApply,
  applyLabel = 'Use recommended address',
}) {
  if (!suggestion) return null

  const {original, recommended, message} = suggestion
  const addressChanged = original.address !== recommended.address
  const cityChanged = original.city !== recommended.city
  const stateChanged = original.state !== recommended.state
  const zipChanged = original.zipCode !== recommended.zipCode

  const mapUrl =
    API_KEY && recommended.lat != null && recommended.lng != null
      ? `https://maps.googleapis.com/maps/api/staticmap?center=${recommended.lat},${recommended.lng}&zoom=15&size=520x140&scale=2&markers=color:red|${recommended.lat},${recommended.lng}&key=${API_KEY}`
      : null

  return (
    <BannerWrap>
      {message && <BannerMessage>{message}</BannerMessage>}
      <ColumnsRow>
        <Column>
          <ColumnLabel>What you entered</ColumnLabel>
          <div>{formatAddress(original)}</div>
        </Column>
        <RecommendedColumn hasMap={!!mapUrl}>
          <RecommendedDetails>
            <ColumnLabel>Recommended</ColumnLabel>
            <div>
              {recommended.address && (
                <>
                  <Token value={recommended.address} changed={addressChanged} />
                  {', '}
                </>
              )}
              <Token value={recommended.city} changed={cityChanged} />
              {', '}
              <Token value={recommended.state} changed={stateChanged} />{' '}
              <Token value={recommended.zipCode} changed={zipChanged} />
            </div>
          </RecommendedDetails>
          {mapUrl && (
            <MapImage src={mapUrl} alt="Map preview of recommended address" />
          )}
        </RecommendedColumn>
      </ColumnsRow>
      <div>
        <Button
          type="button"
          variant="secondary-blue"
          onClick={() => {
            const trim = v => (typeof v === 'string' ? v.trim() : v)
            onApply?.({
              address: trim(recommended.address),
              city: trim(recommended.city),
              state: trim(recommended.state),
              postCode: trim(recommended.zipCode),
            })
          }}
        >
          {applyLabel}
        </Button>
      </div>
    </BannerWrap>
  )
}
